// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/app/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import ExperimentOutlined from '/app/node_modules/@ant-design/icons/es/icons/ExperimentOutlined';
import DatabaseOutlined from '/app/node_modules/@ant-design/icons/es/icons/DatabaseOutlined';
export default { DashboardOutlined, ExperimentOutlined, DatabaseOutlined };
